import React from "react";

const GridExplore = ({ data }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5 lg:gap-6 p-2">
    {data.map((program) => (
      <div className="bg-white flex flex-col shadow-lg rounded-lg overflow-hidden md:max-w-[260px] md:min-h-[340px] lg:max-w-[280px] lg:min-h-[360px]">
        <div className="relative p-2 md:p-1 lg:p-2">
          <div className="relative">
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}/university/image/${program.universityId}.jpg`}
              alt={program.universityName}
              className="w-full h-40 md:h-32 lg:h-40 rounded-md object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b rounded-t-md from-[rgba(0,0,0,0.6)] to-transparent opacity-60"></div>
            <div className="absolute inset-0 bg-gradient-to-t rounded-t-md from-[rgba(0,0,0,0.8)] to-transparent opacity-60"></div>
          </div>
        </div>
        <div className="flex flex-col justify-between p-4 md:p-2 lg:p-4 h-full">
          {/* University Name Below Image */}
          <p className="text-[#04236B] font-semibold text-[13px] md:text-[12px] lg:text-[14px] mb-2" style={{ backgroundColor: 'rgba(201, 219, 255, 0.45)', padding: '4px 8px', borderRadius: '5px', maxWidth: 'fit-content' }}>
            {program.universityName}
          </p>
          
          {/* Program Name */}
          <h1 className="text-primary-color text-base md:text-sm lg:text-lg font-semibold flex-grow">{program.programName}</h1>
          
          {/* Application Due Section with the new styling */}
          <p className="text-[#999999] text-[13px] md:text-[12px] lg:text-[14px] font-semibold mb-2">
            Application Due: {getTwoDaysFromNow()}
          </p>
          
          {/* Button Section */}
          <div className="flex justify-between gap-2 md:gap-1 lg:gap-4 mt-2">
            <button
              className="primary-small-Btn-fillScale w-full px-4 md:px-2 lg:px-8 py-2 text-xs md:text-[11px] lg:text-sm transition-all duration-200 transform hover:scale-105"
              onClick={() => console.log("view")}
            >
              View
            </button>
            <button
              className="primary-small-Btn-HollowScale w-full px-4 md:px-2 lg:px-8 py-2 text-xs md:text-[11px] lg:text-sm transition-all duration-200 transform hover:scale-105"
              onClick={() => console.log("syllabus")}
            >
              Syllabus
            </button>
          </div>
        </div>
      </div>
    ))}
  </div>
  
  
  );
};

export default GridExplore;

function getTwoDaysFromNow() {
  const today = new Date();
  const twoDaysLater = new Date(today);
  twoDaysLater.setDate(today.getDate() + 2);

  // Format the date as desired (e.g., "Jan 13, 2025")
  const options = { year: "numeric", month: "short", day: "numeric" };
  return twoDaysLater.toLocaleDateString("en-US", options);
}
